import { styled } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

import type {
  ProgressRingColor,
  ProgressRingSize,
} from 'ui/progress-ring/progress-ring.types';

interface ProgressRingRootOwnerState {
  ringColor: ProgressRingColor;
}

interface ProgressRingLabelOwnerState {
  ringColor: ProgressRingColor;
  ringSize: ProgressRingSize;
}

const RING_COLOR: Record<ProgressRingColor, (theme: Theme) => string> = {
  secondary: (theme) => theme.palette.secondary.main,
  success: (theme) => theme.palette.tokens.success[600],
  warning: (theme) => theme.palette.tokens.amber[500],
  error: (theme) => theme.palette.error.main,
  inherit: () => 'inherit',
};

const LABEL_VARIANT = { small: 'subtitle2', medium: 'subtitle1' } as const;

const isOwnProp = (prop: PropertyKey) =>
  prop !== 'ringColor' && prop !== 'ringSize';

export const ProgressRingRoot = styled('span', {
  shouldForwardProp: isOwnProp,
})<ProgressRingRootOwnerState>(({ theme, ringColor }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0,
  gap: theme.spacing(0.75),
  color: RING_COLOR[ringColor](theme),
}));

export const ProgressRingLabel = styled('span', {
  shouldForwardProp: isOwnProp,
})<ProgressRingLabelOwnerState>(({ theme, ringColor, ringSize }) => ({
  ...theme.typography[LABEL_VARIANT[ringSize]],
  color:
    ringColor === 'secondary'
      ? theme.palette.secondary.main
      : theme.palette.text.primary,
}));
